import { Component } from '@angular/core';

@Component({
  selector: 'app-reset-password-invalid',
  templateUrl: './reset-password-invalid.component.html',
  styleUrls: ['./reset-password-invalid.component.css']
})
export class ResetPasswordInvalidComponent { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.ts